import { Select } from '@sumup/circuit-ui';
import { withNoMargin } from '../hocs';

const NoMarginSelect = withNoMargin(Select);

export { NoMarginSelect as Select };
